<script lang="ts">
	import CameraRecordingsComponent from 'src/components/Camera/DeviceDrawer/RecordingsTab/CameraRecordingsComponent.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<DeviceViewStateWrapper {device} ignoreOfflineState>
	<div slot="content" class="flex-full-height justify-content-start">
		<CameraRecordingsComponent {device} />
	</div>
</DeviceViewStateWrapper>
